import * as React from 'react';
import { Search } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SearchFieldProps {
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  placeholder?: string | undefined;
  className?: string | undefined;
}

/**
 * Campo de busca do protótipo: ícone de lupa à esquerda, fundo surface-2,
 * borda transparente que escurece (foreground) no foco. O ícone também
 * escurece quando o input está em foco (group-focus-within).
 */
export const SearchField = React.forwardRef<HTMLInputElement, SearchFieldProps>(
  ({ value, onChange, placeholder, className }, ref) => {
    return (
      <div className={cn('group relative', className)}>
        <span className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-muted-foreground transition-colors group-focus-within:text-foreground">
          <Search size={16} />
        </span>
        <input
          ref={ref}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          // text-base (16px) evita zoom no iOS
          className="w-full rounded-lg border border-transparent bg-surface-2 py-2.5 pl-10 pr-3.5 text-base text-foreground outline-none transition-colors focus:border-foreground placeholder:text-muted-foreground"
        />
      </div>
    );
  },
);
SearchField.displayName = 'SearchField';
